export default __webpack_public_path__ + "images/reason-bg.png?cc2a004005d0ea790588d7fff99fd72f";